import React, { useState } from 'react';
import Terms from './Terms';
import './Footer.css';

const Footer = () => {
    const [showTermsModal, setShowTermsModal] = useState(false);

    const handleTermsClick = () => {
        setShowTermsModal(true);
    };

    const handleCloseTerms = () => {
        setShowTermsModal(false);
    };

    return (
        <>
            <footer className="site-footer">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3 className="footer-title">RF4 데이터 사이트</h3>
                        <div className="footer-info">
                            <div className="footer-info-item">
                                <span className="footer-info-icon">ℹ️</span>
                                <span>비영리 게임 정보 사이트</span>
                            </div>
                            <div className="footer-info-item">
                                <span className="footer-info-icon">🎮</span>
                                <span>Russian Fishing 4</span>
                            </div>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h3 className="footer-title">정보</h3>
                        <div className="footer-links">
                            <button 
                                className="footer-link"
                                onClick={handleTermsClick}
                            >
                                이용약관 및 개인정보처리방침
                            </button>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h3 className="footer-title">법적 고지</h3>
                        <div className="footer-info">
                            <div className="footer-info-item">
                                <span className="footer-info-icon">©️</span>
                                <span>모든 게임 콘텐츠 및 자료의 저작권은 원작자에게 있습니다</span>
                            </div>
                            <div className="footer-info-item">
                                <span className="footer-info-icon">⚠️</span>
                                <span>본 사이트는 팬메이드 프로젝트이며 상업적 목적이 없습니다</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-copyright">
                        © {new Date().getFullYear()} RF4 Datasite. All rights reserved.
                    </div>
                    <div className="footer-disclaimer">
                        본 사이트는 비영리 목적으로 운영되며, 게임 데이터의 저작권은 원 제작사에 있습니다.
                    </div>
                </div>
            </footer>

            {/* 약관 모달 */}
            {showTermsModal && (
                <div className="terms-modal-overlay" onClick={handleCloseTerms}>
                    <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="terms-modal-header">
                            <h2 className="terms-modal-title">이용약관 및 개인정보처리방침</h2>
                            <button 
                                className="terms-modal-close"
                                onClick={handleCloseTerms}
                                aria-label="닫기"
                            >
                                ×
                            </button>
                        </div>
                        <div className="terms-modal-body">
                            <Terms />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
